<div class="wrapper">
  <div class="modal-header">
    <h2>{{data.key == 'invoiceFilter' ? 'Filter' : 'Sort'}} {{title}} by</h2>
    <button class="close-btn" (click)="dismissModal()"><i class="fa fa-times"></i></button>
  </div>

  <div class="modal-content">
    <ion-list>
      <ion-radio-group [(ngModel)]="selectedSortOption" (ionChange) = "handleCheckboxSelect(selectedSortOption)">
        <ion-item *ngFor="let option of sortOptions">
          <ion-label class="sort-label">{{ option.label }}</ion-label>
          <ion-radio slot="end" [value] = "option.value"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
  </div>


  <div class="modal-footer">
    <ion-button class="dismiss" fill="clear" (click)="resetSort()">Reset</ion-button>
    <ion-button [disabled]="!selectedSortOption" class="apply-btn" type="submit" color="basic" (click)="applySort()">
      <div class="apply-txt">Apply</div>
      <div class="ellipse"><i class="fas fa-arrow-right"></i></div>
    </ion-button>
  </div>
</div>